
import { useState } from "react";
import ContentEditor from "./ContentEditor";
import ContentPreview from "./ContentPreview";
import ContentTabHeader from "./ContentTabHeader";

interface PrivacyTabProps {
  privacyValue: string;
  setPrivacyValue: (value: string) => void;
  getLastUpdatedText: (key: string) => string;
  handleSavePrivacy: () => void;
  saving: boolean;
}

const PrivacyTab = ({
  privacyValue,
  setPrivacyValue,
  getLastUpdatedText,
  handleSavePrivacy,
  saving
}: PrivacyTabProps) => {
  const [previewMode, setPreviewMode] = useState(false);
  
  return (
    <div className="space-y-4">
      <ContentTabHeader 
        lastUpdated={getLastUpdatedText("privacy_policy")}
        previewMode={previewMode}
        togglePreview={() => setPreviewMode(!previewMode)}
        handleSave={handleSavePrivacy}
        saving={saving}
      />
      
      {previewMode ? (
        <ContentPreview content={privacyValue} />
      ) : (
        <ContentEditor 
          value={privacyValue}
          onChange={setPrivacyValue}
        />
      )}
    </div>
  );
};

export default PrivacyTab;
